/** Human names for the ids the usage API returns — shared by every spend screen. */
export const SERVICE_LABELS = {
    llm: 'Language models',
    realtime: 'Realtime voice',
    realtime_transcription: 'Realtime transcription',
    stt: 'Speech-to-text',
    tts: 'Text-to-speech',
};
export const PROVIDER_LABELS = {
    openai: 'OpenAI',
    azure: 'Azure',
    sarvam: 'Sarvam',
    elevenlabs: 'ElevenLabs',
    deepgram: 'Deepgram',
    google: 'Google',
    gemini: 'Gemini',
};
export const MODE_NAMES = {
    realtime: 'Realtime',
    cost_optimized: 'Cost-optimized',
    pre_interview: 'Pre-interview',
    unknown: 'Unknown',
};
export const providerName = (p) => { var _a; return (p ? (_a = PROVIDER_LABELS[p]) !== null && _a !== void 0 ? _a : p : ''); };
export const serviceName = (s) => { var _a; return (s ? (_a = SERVICE_LABELS[s]) !== null && _a !== void 0 ? _a : s : ''); };
export const modeName = (m) => { var _a; return (m ? (_a = MODE_NAMES[m]) !== null && _a !== void 0 ? _a : m.replace(/_/g, ' ') : ''); };
